import React from 'react';
export function Requirements() {
  const moralRequirements = ['Acta Constitutiva con Sello del RPP.', 'Poderes de los Firmantes.', 'Identificación de los Firmantes.', 'Cédula de RFC.', 'Comprobante de Domicilio con Antigüedad Máxima de 3 Meses.', 'Estados Financieros Auditados 2012 y 2013.', 'Estados Financiero Internos de 2014 más recientes disponibles.', 'Declaraciones Fiscales 2012, 2013.', 'Copia de Estados de Cuenta Completos de los Últimos Tres Meses.', 'Solicitud de Arrendamiento en Original para el Acreditado.', 'Carta Autorizando la Consulta en el Buró de Crédito del Acreditado y del Aval o Avales.', 'Identificación y Comprobante de Domicilio del Aval o Avales.', 'Comprobante de Domicilio.', 'Formato consulta Buró de Crédito en Original.'];
  const fisicaRequirements = ['Identificación Oficial.', 'Comprobante de Domicilio con Antigüedad Máxima 3 Meses.', 'Solicitud de Arrendamiento formato en original.', 'Autorización de Consulta a Buró de Crédito en Original.', 'Declaración Anual 2012, 2013 y 2014.', 'Estados Financieros Parciales Últimos 2014.', 'Estados Financieros Anuales/Dictaminados 2012 y 2013.', 'Estado de cuenta Bancarios últimos 3 Meses', 'Cédula RFC.', 'Alta en Hacienda.', 'Identificación Oficial.', 'Comprobante de Domicilio.', 'Formato Consulta Buró de Crédito en Original.'];
  return <section id="contacto" className="py-20 bg-white" data-id="element-201">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-202">
        <div className="mb-16" data-id="element-203">
          <h2 className="text-4xl font-light text-gray-900 mb-4" data-id="element-204">Requisitos</h2>
          <p className="text-xl text-gray-600" data-id="element-205">
            Documentación necesaria para acreditar el Arrendamiento
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-206">
          {/* Persona Moral */}
          <div data-id="element-207">
            <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-208">
              Persona Moral
            </h3>
            <ul className="space-y-3" data-id="element-209">
              {moralRequirements.map((req, index) => <li key={index} className="text-gray-700 flex items-start" data-id="element-210">
                  <span className="text-[#2BA6DE] mr-3 mt-1" data-id="element-211">•</span>
                  <span data-id="element-212">{req}</span>
                </li>)}
            </ul>
          </div>

          {/* Persona Física */}
          <div data-id="element-213">
            <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-214">
              Persona Física con Actividad Empresarial
            </h3>
            <ul className="space-y-3" data-id="element-215">
              {fisicaRequirements.map((req, index) => <li key={index} className="text-gray-700 flex items-start" data-id="element-216">
                  <span className="text-[#2BA6DE] mr-3 mt-1" data-id="element-217">•</span>
                  <span data-id="element-218">{req}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}